import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
import { useFormikContext } from 'formik';
export function ValidationAlert() {
    const { errors } = useFormikContext();
    if (!errors.downloadType) {
        return null;
    }
    return (<Alert appearance="warning" message={t({
            message: 'Please select a download type',
            comment: 'Document download dialog - Error alert message for download type',
        })}/>);
}
